/*
 * Forsala / Væntanlegt badges on product grids (USF search & collections, theme product cards).
 * Same rules as the product page button (snippets/forsala-status.liquid), decided per product
 * from /products/<handle>?view=badge (templates/product.badge.liquid).
 */
(function () {
  var CARDS = '.usf-sr-product, .product-card';
  var CACHE_MS = 15 * 60 * 1000;
  var MAX_REQUESTS = 4;

  // Iceland is UTC all year, so the UTC date is the local date.
  var today = new Date().toISOString().slice(0, 10);
  var pending = {};
  var queue = [];
  var running = 0;

  function cached(key) {
    try {
      var entry = JSON.parse(sessionStorage.getItem(key));
      if (entry && Date.now() - entry.t < CACHE_MS) return entry.d;
    } catch (e) {}
    return null;
  }

  function remember(key, data) {
    try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: data })); } catch (e) {}
  }

  function next() {
    while (running < MAX_REQUESTS && queue.length) {
      running++;
      queue.shift()();
    }
  }

  function load(path) {
    var key = 'forsala-badge:' + path;
    var hit = cached(key);
    if (hit) return Promise.resolve(hit);
    if (pending[path]) return pending[path];

    pending[path] = new Promise(function (resolve) {
      queue.push(function () {
        fetch(path + '?view=badge', { credentials: 'same-origin' })
          .then(function (res) { return res.ok ? res.text() : null; })
          .then(function (text) {
            // Theme preview wraps the reply in its preview bar, so pick out our JSON.
            var json = text && text.match(/\{"forsala"[^{}]*\}/);
            var data = json ? JSON.parse(json[0]) : null;
            if (data) remember(key, data);
            resolve(data);
          })
          .catch(function () { resolve(null); })
          .then(function () { running--; delete pending[path]; next(); });
      });
      next();
    });
    return pending[path];
  }

  function badgeFor(data) {
    if (!data) return null;
    var future = data.releaseDate && data.releaseDate > today;
    if (data.forsala && data.available && (future || !data.inStock)) return 'forsala';
    if (future) return 'vaentanlegt';
    if (!data.available && data.incoming) return 'vaentanlegt';
    return null;
  }

  function productPath(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var match = new URL(link.getAttribute('href'), location.href).pathname.match(/^.*?\/products\/[^\/?#]+/);
    return match ? match[0] : null;
  }

  var visible = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      visible.unobserve(entry.target);
      check(entry.target);
    });
  }, { rootMargin: '1000px 0px' }) : null;

  function apply(card, data) {
    var badge = badgeFor(data);
    if (badge) card.setAttribute('data-forsala-badge', badge);
    else card.removeAttribute('data-forsala-badge');
  }

  function check(card) {
    var path = card.getAttribute('data-forsala-path');
    load(path).then(function (data) {
      // The search app reuses cards for other products; ignore stale answers.
      if (card.getAttribute('data-forsala-path') === path) apply(card, data);
    });
  }

  // Theme product cards carry their status in the page (snippets/forsala-badge-data.liquid).
  function inlineInfo(card) {
    try { return JSON.parse(card.getAttribute('data-forsala-info')); } catch (e) { return null; }
  }

  function scan() {
    document.querySelectorAll(CARDS).forEach(function (card) {
      var path = productPath(card);
      if (card.getAttribute('data-forsala-path') === path) return;
      card.removeAttribute('data-forsala-badge');
      if (!path) {
        card.removeAttribute('data-forsala-path');
        return;
      }
      card.setAttribute('data-forsala-path', path);
      var info = card.hasAttribute('data-forsala-info') && inlineInfo(card);
      if (info) apply(card, info);
      else if (visible) visible.observe(card);
      else check(card);
    });
  }

  var timer;
  function scheduleScan() {
    clearTimeout(timer);
    timer = setTimeout(scan, 50);
  }

  new MutationObserver(scheduleScan).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['href']
  });
  scan();
})();
